import { getDashboardRequest, getWalletRequest } from '../../api/DashboardRequest';
import { GET_DASHBOARD, GET_WALLET, LOAD_DONE, LOAD_REQUEST } from '../types';
import { checkIfResponseOk } from './AuthActions';

export const getWalletAction = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REQUEST });

    const { data } = await getWalletRequest();

    checkIfResponseOk(data, dispatch);

    dispatch({ type: GET_WALLET, payload: data.content.data });
    return 0;
  } catch (err) {
    dispatch({ type: LOAD_DONE });
    return { error: 1, message: err.message };
  }
};

export const getDashboardAction = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REQUEST });

    const { data } = await getDashboardRequest();

    checkIfResponseOk(data, dispatch);

    dispatch({ type: GET_DASHBOARD, payload: data.content.data });
    return 0;
  } catch (err) {
    dispatch({ type: LOAD_DONE });
    return { error: 1, message: err.message };
  }
};
